import React from 'react'
import { projectData } from '../data/data'
import { Link } from 'react-router-dom'

export default function Project() {
  return (
        <div className="row">
            {projectData.map((item,index)=>{
                return(
                    <div className="col-lg-4 col-md-4 mt-4 pt-2" key={index}>
                        <div className="portfolio rounded shadow position-relative overflow-hidden">
                            <div className="position-relative overflow-hidden image">
                                <img src={item.image} className="img-fluid" alt=""/>
                                <div className="position-absolute start-0 end-0 top-0 bottom-0 overlay"></div>
                            </div>

                            <div className="content p-3 bg-white position-absolute bottom-0 start-0 end-0 rounded shadow m-4">
                                <Link to="" className="text-dark fs-5 fw-medium link-title">{item.title}</Link>
                                <p className="text-muted mb-0">{item.subTitle}</p>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
  )
}
